import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgDownPayment(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="7 14 46 34"
      fill="none"
      {...props}
    >
      <path
        fill={props.secondaryColor}
        d="M47.076 32.228c.952-.952-.495-2.399-1.447-1.447h.002l-3.804 3.804c-.954.952.494 2.4 1.446 1.447zM12.927 23.142c-.953.952.495 2.399 1.447 1.447h-.002l3.803-3.804c.954-.952-.493-2.4-1.445-1.447z"
      />
      <path
        fill={props.primaryColor}
        d="M49.309 39.447h-.628l-1.823 6.808c-.146.545-.707.87-1.252.724l-28.105-7.532h-6.808a1.023 1.023 0 0 1-1.022-1.023v-21.48c0-.566.457-1.023 1.022-1.023H49.31c.566 0 1.023.457 1.023 1.023v21.48c0 .566-.457 1.023-1.023 1.023zm-2.742 0H25.396l19.754 5.292zm-34.85-2.043h36.57V17.968h-36.57z"
      />
      <path
        fill={props.secondaryColor}
        fillRule="evenodd"
        d="M30.857 24.21h-1.71c-.505 0-.855.295-.855.561v1.398c0 .267.35.56.855.56h1.71c1.415 0 2.566 1.006 2.566 2.24v1.398c0 1.235-1.15 2.24-2.566 2.24v1.267l-.002.001a.855.855 0 0 1-1.705.02h-.003v-1.288c-1.416 0-2.566-1.005-2.566-2.24 0-.463.383-.84.855-.84.473 0 .855.377.855.84 0 .267.351.56.856.56h1.71c.505 0 .855-.293.855-.558v-1.4c0-.266-.35-.56-.855-.56h-1.71c-1.416 0-2.566-1.006-2.566-2.238v-1.4c0-1.234 1.15-2.24 2.566-2.24v-1.26c0-.463.382-.839.855-.839.472 0 .855.376.855.84v1.26c1.415 0 2.566 1.005 2.566 2.24 0 .463-.383.839-.856.839a.847.847 0 0 1-.855-.84c0-.266-.35-.56-.855-.56"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default SvgDownPayment;
